import { ARBITRARY_ID_INITIAL_DATA, DOMAIN_TYPE_ARBITRARY } from '../../../consts';
export var getInitialData = function (state) {
    return (state.domain[DOMAIN_TYPE_ARBITRARY] || {})[ARBITRARY_ID_INITIAL_DATA] || null;
};
